import React, { useEffect, useState } from 'react';
import { useDataTable } from '../../DataTable';
import { useBarcodeScanner } from '@/app/hooks/useBarcodeScanner';

const BaseSearchFilter: React.FC = () => {
  const { table, searchPlaceHolder, searchTerm, setSearchTerm, enableBarcodeSearch } = useDataTable();
  const [isScanPulsing, setIsScanPulsing] = useState(false);

  useBarcodeScanner((code) => {
    setSearchTerm(code);
    setIsScanPulsing(true);
  }, enableBarcodeSearch);

  useEffect(() => {
    if (!isScanPulsing) return;
    const timer = setTimeout(() => setIsScanPulsing(false), 500);
    return () => clearTimeout(timer);
  }, [isScanPulsing]);

  useEffect(() => {
    if (!table) return;
    table.setGlobalFilter(searchTerm);
  }, [searchTerm, table]);

  return (
    <div className="position-relative w-100 w-md-330px w-xl-400px">
      <input
        aria-label={searchPlaceHolder}
        autoComplete="off"
        className="form-control form-control-solid w-100"
        name="data-table-search"
        placeholder={searchPlaceHolder}
        style={{ height: '43.56px', paddingRight: enableBarcodeSearch ? '40px' : undefined }}
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {!!enableBarcodeSearch && (
        <i
          aria-hidden="true"
          className={`bi bi-upc-scan position-absolute top-50 translate-middle-y ${
            isScanPulsing ? 'text-success' : 'text-gray-500'
          }`}
          style={{ fontSize: '16px', right: '13px' }}
          title="Leitor de código de barras ativo"
        />
      )}
    </div>
  );
};

export default BaseSearchFilter;
